<template>
  <div
    :class="
      !$route.params.modelname
        ? 'vs-component con-vs-popup vs-popup-primary cstm-modal-popup show'
        : ''
    "
  >
    <div class="cstm-modal medium fixed_medium">
      <div class="header p-0" v-if="!$route.params.modelname">
        <button @click.stop="closePopup" class="close-modal">&times;</button>
      </div>
      <div
        style="max-height: calc(100vh - 300px); overflow-y: auto"
        class="table_responsive vertical_scrollbar"
      >
        <div :class="$route.params.modelname ? 'filter-col' : ''">
          <vx-card
            :title="list.filter_name"
            v-for="(list, index) in listData"
            :key="index"
          >
            <vs-button
              style="float: right"
              icon-pack="feather"
              @click="openConfirm(list.filter_id)"
              color="danger"
              icon="icon-trash-2"
            ></vs-button>

            <vs-list class="list-holder">
              <vs-list-item
                class="filter-list-item"
                v-for="(userModule, userModuleindex) in list.userModuleFilter"
                :key="userModuleindex"
              >
                <template slot="avatar">
                  <vs-row
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    class="bg-primary"
                    style="
                      height: 30px;
                      width: 30px;
                      border-radius: 50%;
                      margin-right: 10px;
                    "
                    ><h4 style="color: white">
                      {{ userModuleindex + 1 }}
                    </h4></vs-row
                  >
                </template>
                <div>
                  <p
                    v-if="
                      userModule &&
                      userModule.field_name &&
                      userModule.field_name.field_label
                    "
                  >
                    <strong>Field Name:</strong>

                    {{ userModule.field_name.field_label || "" }}
                  </p>
                  <strong>Filter Condition:</strong>
                  {{ userModule.filter_condition.filter_name || "" }}<br />
                  <strong>Filter Value:</strong>
                  {{ userModule.filter_value || "" }}
                </div>
              </vs-list-item>
            </vs-list>
          </vx-card>
          <vx-card v-if="listData.length==0">
            No data found
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAllFilterListOfModule, deleteFilterMain } from '@/api/filter'

export default {
  props: {
    modelnamePass: {
      default: ''
    },
    table_name: {
      default: ''
    }
  },
  data () {
    return {
      listData: [],
      deleted_id: ''
    }
  },
  mounted () {
    if (this.$route.params.modelname) {
      this.table_name = this.$route.params.table_name
    }
    this.fetchList(
      this.$route.params.modelname
        ? this.$route.params.modelname
        : this.modelnamePass
    )
   
  },
  methods: {
    closePopup () {
      this.$emit('closeFilterModal', true)
    },
    async fetchList (moduleName) {
      try {
        this.$vs.loading({ text: 'Fetching Filter List' })
        const customerId = this.$store.getters.customerId

        const { data } = await getAllFilterListOfModule(moduleName, customerId, {table_name:this.table_name})
        this.listData = data.data.fields
      } catch (error) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    openConfirm (id) {
      this.deleted_id = id

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this filter?',
        accept: this.acceptAlert
      })
    },

    acceptAlert () {
      this.deleteFilter(this.deleted_id)
    },

    async deleteFilter (id) {
      try {
        await deleteFilterMain(id)

        const index = this.listData.findIndex((el) => el.filter_id === id)

        this.listData.splice(index, 1)
        this.showSuccessMessage(
          'Deleted',
          'Custom Filter Deleted Successfully',
          'success'
        )
      } catch (error) {}
    }
  }
}
</script>

<style>
.filter-col {
  display: flex;
  flex-wrap: wrap;
}
.filter-col .vx-card__header {
  padding: 1.5rem;
  box-shadow: 0 7px 7px -5px rgba(0, 0, 0, 0.08);
}
.filter-col .vx-card__header h4 {
  color: rgba(var(--vs-primary), 1);
  font-weight: 700;
  font-size: 16px;
}
.filter-col .vx-card {
  width: calc(50% - 20px);
  margin: 0 10px 10px;
}
.filter-col .vx-card__collapsible-content {
  margin-bottom: 10px;
}
.filter-col .vx-card__body {
  height: 140px;
  overflow: auto;
}
.filter-list-item .vs-list--slot {
  width: 100%;
  margin-left: 10px;
}
.delete-btn {
  position: absolute;
  right: 1.5rem;
  top: -50px;
}
.filter-col .vx-card ::-webkit-scrollbar {
  width: 5px;
}
.filter-col .vx-card ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
.filter-col .vx-card ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}
@media (min-width: 1920px) {
  .v-nav-menu .vs-sidebar {
    max-width: 12%;
  }
  #content-area.content-area-reduced {
    margin-left: 12%;
  }
  .filter-col .vx-card {
    width: calc(33.33% - 20px);
    margin: 0 10px 10px;
  }
}
@media (max-width: 768px) {
  .filter-col .vx-card {
    width: calc(100% - 20px);
  }
}
</style>